import { createSelector } from 'reselect';
import { get, isEqual } from 'lodash';
import { widgetsByIdSelector } from './widget-selectors';

// Canvas
const activeCanvasSelector = ( state, props ) => get( state, `canvases.byId[${props.match.params.canvasId}]`, null );
export const canvasByIdSelector = state => get( state, 'canvases.byId', {} );
export const canvasFormStateSelector = state => get( state, 'canvases.formState', {} );

export const canvasFormIsDirtySelector = createSelector(
    activeCanvasSelector,
    canvasFormStateSelector,
    ( canvas, formState ) => !isEqual( canvas.params, formState )
);

/* Returns all widgets for the currently selected canvas */
export const selectedCanvasWithWidgetsSelector = createSelector(
    activeCanvasSelector,
    widgetsByIdSelector,
    ( canvas, widgetsMap ) => {
        if( !canvas ){
            return null;
        }

        return {
            ...canvas,
            widgets: canvas.widgets.map( ( widgetId ) => widgetsMap[widgetId] )
        };
    }
);
